import { BASE_PATH_API } from '@root/manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';
import { CreateTaskWorkSessionDTO } from '@root/app/tasks/data/dtos/create-task-work-session.dto';
import { StopWorkSessionDTO } from '@root/app/tasks/data/dtos/stop-work-session.dto';
import { WorkSessionDTO } from '@root/app/tasks/data/dtos/work-session.dto';

const actions = {
    createTaskWorkSession: {
        method: 'POST',
        url: `${BASE_PATH_API}/taskWorkSessions`
    },
    createWorkOrderWorkSession: {
        method: 'POST',
        url: `${BASE_PATH_API}/workOrderWorkSessions`
    },
    getActiveWorkSession: {
        method: 'GET',
        url: `${BASE_PATH_API}/worksessions/self`
    },
    stopWorkSession: {
        method: 'PUT',
        url: `${BASE_PATH_API}/worksessions/self`
    },
    getWorkSessions: {
        method: 'GET',
        url: `${BASE_PATH_API}/worksessions`
    }
};

export interface IWorkSessionsApi {
    createTaskWorkSession(createWorkSession: CreateTaskWorkSessionDTO): Promise<WorkSessionDTO>;
    createWorkOrderWorkSession(createWorkSession: CreateTaskWorkSessionDTO): Promise<WorkSessionDTO>;
    stopWorkSession(stopWorkSession: StopWorkSessionDTO): Promise<WorkSessionDTO>;
    getActiveWorkSession(): Promise<WorkSessionDTO>;
    getWorkSessions(params: { TaskId: number }): Promise<WorkSessionDTO[]>;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function WorkSessionsApi(): IWorkSessionsApi {
    return createActions(actions);
}
